module.exports = __webpack_public_path__ + "assets/img/logo.635c83c1.png";